// import Index from '@/views/Index'
// import EconomicGroupsBuyers from '@/views/buyers/EconomicGroupsBuyers'
// import ViewBuyer from '@/views/buyers/ViewBuyer'
// import BuyerOfferRules from '@/views/buyers/BuyerOfferRules'
// import ProviderOfferRules from '@/views/buyers/ProviderOfferRules'
// import ProvidersByEconomicGroup from '@/views/buyers/ProvidersByEconomicGroup'
const Index = () => import('@/views/Index.vue');
const EconomicGroupsBuyers = () => import('@/views/buyers/EconomicGroupsBuyers.vue');
const ViewBuyer = () => import('@/views/buyers/ViewBuyer.vue');
const BuyerOfferRules = () => import('@/views/buyers/BuyerOfferRules.vue');
const ProviderOfferRules = () => import('@/views/buyers/ProviderOfferRules.vue');
const ProvidersByEconomicGroup = () => import('@/views/buyers/ProvidersByEconomicGroup.vue');



const opportunitiesRouter = {
    name: 'buyers',
    path: '/buyers',
    component: Index,
    meta: {
        title: 'Cashforce - Sacados',
        requiresAuth: true
    },
    children: [
        {
            name: "marketplace/buyer",
            path: '/',
            component: EconomicGroupsBuyers,
            meta: {
                title: 'Cashforce - Sacados',
                requiresAuth: true
            },
        },
        {
            name: "marketplace/buyer",
            path: 'offerRules/:economicGroupId',
            component: BuyerOfferRules,
            meta: {
                title: 'Cashforce - Sacados',
                requiresAuth: true
            },
        },
        {
            name: "marketplace/buyer",
            path: 'providers/offerRules/:economicGroupId/:providerId',
            component: ProviderOfferRules,
            meta: {
                title: 'Cashforce - Sacados',
                requiresAuth: true
            },
        },
        {
            name: "marketplace/buyer",
            path: 'providers/:economicGroupId',
            component: ProvidersByEconomicGroup,
            meta: {
                title: 'Cashforce - Sacados',
                requiresAuth: true
            },
        },
        {
            name: "marketplace/buyer",
            path: ':economicGroupId',
            component: ViewBuyer,
            meta: {
                title: 'Cashforce - Sacados',
                requiresAuth: true
            },
        },
    ]
}

export default opportunitiesRouter;